import { render, staticRenderFns } from "./LinksTab.htm?vue&type=template&id=3b681a4e&scoped=true&"
import script from "./LinksTab.ts?vue&type=script&lang=js&"
export * from "./LinksTab.ts?vue&type=script&lang=js&"
import style0 from "./LinksTab.scss?vue&type=style&index=0&id=3b681a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b681a4e",
  null
  
)

export default component.exports